import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HttpClientJsonpModule, HttpClientModule, withJsonpSupport } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes, withInMemoryScrolling({
      scrollPositionRestoration: 'enabled',
    }),),
    provideAnimations(),
    provideToastr(),
    withJsonpSupport().ɵproviders,
    importProvidersFrom(HttpClientJsonpModule, HttpClientModule)
  ],
};
